import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as CompanyProfileLogo } from "images/userDetails/companyProfile.svg";
import ProfileSection from "../common/profileSection";
import CompanyDetails from "./companyDetails";
import ContactDetails from "./contactDetails";

import Availability from "../common/availability";
import { useSelector } from "react-redux";
import {
  STATUS_ACTIVE,
  STATUS_BLACKLIST,
  STATUS_QUALIFIED,
  STATUS_SUSPENDED,
  SUBSTATUS_AGREEMENT_SENT,
  SUBSTATUS_DECLINED_AGREEMENT,
  SUBSTATUS_DO_NOT_USE,
  SUBSTATUS_EXPIRED_AGREEMENT,
  SUBSTATUS_ONBOARDING_DONE,
  SUBSTATUS_PENDING_INVESTIGATION,
  SUBSTATUS_READY_FOR_WORK,
  SUBSTATUS_UNDER_VALIDATION,
} from "utils/constantValues";
import Experience from "./experiance/index";

function AgencyDetails() {
  const [t] = useTranslation();
  const userDetails = useSelector((state) => state.userDetails || {});
  const isShowEditIcon = ![STATUS_BLACKLIST, STATUS_SUSPENDED].includes(
    userDetails?.status
  );
  const isActive =
    userDetails.status === STATUS_ACTIVE &&
    userDetails.subStatus === SUBSTATUS_READY_FOR_WORK;

  const showOnboardingForum =
    [
      STATUS_ACTIVE,
      STATUS_QUALIFIED,
      STATUS_BLACKLIST,
      STATUS_SUSPENDED,
    ].includes(userDetails?.status) &&
    [
      SUBSTATUS_READY_FOR_WORK,
      SUBSTATUS_ONBOARDING_DONE,
      SUBSTATUS_PENDING_INVESTIGATION,
      SUBSTATUS_DO_NOT_USE,
      SUBSTATUS_AGREEMENT_SENT,
      SUBSTATUS_DECLINED_AGREEMENT,
      SUBSTATUS_EXPIRED_AGREEMENT,
      SUBSTATUS_UNDER_VALIDATION,
    ].includes(userDetails?.subStatus);

  return (
    <ProfileSection
      icon={CompanyProfileLogo}
      title={t("companyDetails")}
      changeLogoButtonText={t("changeLogo")}
      logoFormatText={t("logoFormat")}
      isActive={isActive}
    >
      <div className="bg-[#E4E4E7] h-[1px] w-full" />
      <CompanyDetails isShowEditIcon={isShowEditIcon} />
      <div className="bg-[#E4E4E7] h-[1px] w-full" />
      <Availability isShowEditIcon={isShowEditIcon} />
      <div className="bg-[#E4E4E7] h-[1px] w-full" />
      <Experience isShowEditIcon={isShowEditIcon} />

      {showOnboardingForum && (
        <>
          <div className="bg-[#E4E4E7] h-[1px] w-full" />
          <ContactDetails isShowEditIcon={isShowEditIcon} />
        </>
      )}
      <div className="bg-[#E4E4E7] h-[1px] w-full" />
    </ProfileSection>
  );
}

export default AgencyDetails;
